import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { getPartnerFilesById } from '../api/getPartnerFilesById'
import { selectPartnerFiles } from '../selectors/selectPartnerFiles'

export const useGetPartnerFiles = (partnerId: string) => {
  const dispatch = useAppDispatch()
  const { data, status, message, meta } = useSelector(selectPartnerFiles, shallowEqual)

  useEffect(() => {
    if (!meta || meta.arg?.['partnerId'] !== partnerId) {
      dispatch(getPartnerFilesById({ partnerId, options: { cacheKey: partnerId } }))
    }
  }, [partnerId, meta, dispatch])

  return { partnerFiles: data, status, message }
}
